import shallow from "zustand/shallow";
import useCurrentDealStore from "../../../stores/DealStore";
import useCurrentRecapStore from "../../../stores/RecapStore";
import useCurrentSaleStore from "../../../stores/SaleStore";
import useCurrentVehicleStore from "../../../stores/InventoryStore";
import useCurrentLeaseStore from "../../../stores/LeaseStore";

const useSetDeal = () => {
	// Deal store
	const { setDealFields, editVehicle } = useCurrentDealStore(
		(state) => ({
			setDealFields: state.setDealFields,
			editVehicle: state.editVehicle,
		}),
		shallow
	);
	const { setRecapFields } = useCurrentRecapStore(
		(state) => ({
			setRecapFields: state.setRecapFields,
		}),
		shallow
	);
	const { setSaleFields } = useCurrentSaleStore(
		(state) => ({
			setSaleFields: state.setSaleFields,
		}),
		shallow
	);
	const { setLeaseFields } = useCurrentLeaseStore(
		(state) => ({
			setLeaseFields: state.setLeaseFields,
		}),
		shallow
	);
	const { editInventoryID } = useCurrentVehicleStore(
		(state) => ({
			editInventoryID: state.editInventoryID,
		}),
		shallow
	);

	const setDeal = (response) => {
		console.log(response);
		let dealVehicle = response.vehicle;
		setDealFields(response);
		setRecapFields(response.deal.recap);
		setSaleFields(response.deal.sale);
		if (response.deal.lease !== null) setLeaseFields(response.deal.lease);
		editInventoryID(response.deal.carRecNum);
		if (dealVehicle === null || dealVehicle.inventoryID === 0) {
			editVehicle(null);
		} else if (dealVehicle.inventoryID !== 0) {
			editVehicle(dealVehicle);
		} else {
			editVehicle(null);
		}
	};

	return setDeal;
};

export default useSetDeal;
